import { CustomersActions } from "../../types";

export function create(customerId: number, data: Object): any {
  return {
    types: CustomersActions.ContactCreate,
    method: "post",
    url: `api/v1/crm/customers/${customerId}/contacts`,
    data,
  };
}

export function update(customerId: number, { id, ...data }: any): any {
  return {
    types: CustomersActions.ContactUpdate,
    method: "put",
    url: `api/v1/crm/customers/${customerId}/contacts/${id}`,
    data,
  };
}

export function destroy(customerId: number, id: number): any {
  return {
    types: CustomersActions.ContactDestroy,
    method: "delete",
    url: `api/v1/crm/customers/${customerId}/contacts/${id}`,
  };
}
